import React from "react";
import styled from "@emotion/styled";
import { RootState, useAppSelector } from "src/common";
import { colors } from "src/theme";

const ProgressBarStyle = styled.div({
  width: '100%',
  backgroundColor: 'transparent',
  height: '7px',
  overflow: 'hidden'
})

const ProgressStyle = styled.div((props: { progress: number }) => ({
  width: `${props.progress}%`,
  backgroundColor: colors.success1,
  height: '100%',
  borderRadius: '0 4px 4px 0',
  transition: 'width 0.3s ease' // Dodajte prijelaz za animaciju
}))

export const ProgressBar = () => {

  const progressBarPercentage = useAppSelector((store: RootState) => store.state.progressBar.percentage);

  return (
    <ProgressBarStyle>
      <ProgressStyle progress={progressBarPercentage}></ProgressStyle>
    </ProgressBarStyle>
  );
}
